import React from "react";

//package import

import { Hidden, Drawer, useTheme, Box } from "@mui/material";
import { drawerClasses } from "@mui/material/Drawer";
import PropTypes from "prop-types";

//user import

import { InsideDrawer } from "./Drawer";

//component

function Sidebar({
	mobileOpen,
	handleDrawerToggle,
	showMobileSideBar = false,
}) {
	//hooks

	const theme = useTheme();

	//render

	return (
    <Box
      component="nav"
      sx={{
        width: {
          md: showMobileSideBar ? "fit-content" : "17rem",
          sm: "fit-content",
          xs: "fit-content",
        },
        flexShrink: { sm: 0 },
      }}
    >
      <Hidden mdUp implementation="css">
        <Drawer
          variant="temporary"
          anchor={theme.direction === "rtl" ? "right" : "left"}
          open={mobileOpen}
          onClose={handleDrawerToggle}
          onClick={handleDrawerToggle}
          sx={{
            display: {
              md: showMobileSideBar ? "block" : "none",
              sm: "block",
              xs: "block",
            },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              minWidth: "17rem",
              backgroundColor: theme.palette.primary.light,
            },
          }}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
        >
          <InsideDrawer />
        </Drawer>
      </Hidden>
      <Hidden smDown implementation="css">
        <Drawer
          sx={{
            display: {
              md: showMobileSideBar ? "none" : "block",
              sm: "none",
              xs: "none",
            },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              minWidth: "17rem",
              backgroundColor: theme.palette.primary.light,
            },
          }}
          variant="permanent"
        >
          <InsideDrawer />
        </Drawer>
      </Hidden>
    </Box>
  );
}
Sidebar.propTypes = {
	mobileOpen: PropTypes?.bool?.isRequired,
	handleDrawerToggle: PropTypes?.func?.isRequired,
};

export default Sidebar;
